const ApiConstants = {
  SIGN_IN: 'auth/admin/signin',
  DASHBOARD: 'dashboard',
  DISPUTE: 'dispute',
  USER: 'user',
  USER_DETAILS: 'user/',
  CALLS: 'calls',
  CALL: 'call',
  PREFERENCE: 'preferences/',
  AVAILABILITY: 'user/availability',
  COUNTRY_PHONE_CODE: 'country-phone-code',
  REGIONS: 'regions',
  CITES: 'cities',
  LANGUAGES: 'language',
  USER_CALL_HISTORY: 'calls/user/',
  USER_STATISTICS_DATA: 'dashboard/statistics/user/',
  SEND_BROADCAST_NOTIFICATION: 'notifications/broadcast/push-notifications',
  GET_NOTIFICATION: 'notifications',
  GET_SINGLE_INVOICE: 'invoices/',
  GET_PAYMENTS: 'invoices',
  PAYMENT_STATISTICS: 'dashboard/statistics/payment',
  DISPUTE_TYPES: 'dispute/types',
  DISPUTE_STATUS: 'dispute/status',
  RECORDING_CALLS: 'recordings/calls/',
  DOWNLOAD_MP4: '/download/mp4',
  VERIFY_OTP_FOR_ADMIN: 'auth/admin/verify-otp',
  RESEND_OTP_FOR_ADMIN: 'auth/resend-otp',
  BLOCK: '/block',
  UNBLOCK: '/unblock',
};

export default ApiConstants;
